(function () {
    'use strict';

    angular.module("imApp").factory("workingOrdersService", ['$ihttp', function ($ihttp) {
        let service = {
            listCustacts: function (parms) {
                return $ihttp.post({
                    method: 27,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
